import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const DisclaimerWrapper = styled.div.withConfig({
  displayName: "PublicMerchCardCurrencyDisclaimer__DisclaimerWrapper"
})(({
  theme,
  $textAlign
}) => ({
  paddingTop: theme.space[400],
  textAlign: $textAlign
}));
export const PublicMerchCardCurrencyDisclaimer = ({
  currencyCode,
  textAlign = 'start'
}) => /*#__PURE__*/_jsx(DisclaimerWrapper, {
  $textAlign: textAlign,
  children: /*#__PURE__*/_jsx(Text, {
    typography: "detail-100",
    color: "text-core-subtle",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "publicPricingPage.merchCard.pricing.currencyDisclaimer",
      options: {
        currencyCode
      }
    })
  })
});